import React from "react";
import { Grid } from "semantic-ui-react";
import "./style.less";
import { useSelector, useDispatch } from "react-redux";
import { useInput } from "../../../common/hooks";
import { updateProfileSelectedBuddy } from "../../../redux/rm-buddies/actions";

function RMBuddyProfileEdit({ onSave }) {
  const selectedRmBuddy = useSelector(({ rmBuddies }) =>
    rmBuddies.rmBuddiesList
      ? rmBuddies.rmBuddiesList.find(e => e._id === rmBuddies.selectedRmBuddyId)
      : null
  );

  const [name, setName] = useInput(selectedRmBuddy.name);
  const [email, setEmail] = useInput(selectedRmBuddy.email);
  const [phone_num, setPhone_num] = useInput(selectedRmBuddy.phone_num);

  const dispatch = useDispatch();

  const saveHandler = () => {
    dispatch(
      updateProfileSelectedBuddy({
        name,
        email,
        mobileNumber: phone_num
      })
    );
    if (onSave) {
      onSave();
    }
  };

  return (
    <div className="RMBuddyDashboard-ProfileEdit">
      <Grid alignItems="baseline" id="ViewGrid">
        <Grid.Column width={16}>
          <h4>BUDDY PROFILE</h4>
          <h3>{selectedRmBuddy.name}</h3>

          <div className="RMBuddyDashboard-ProfileEditMain">
            <Grid alignItems="flex-end">
              <Grid.Column width={2}>
                <h5>
                  {" "}
                  {`${selectedRmBuddy.name.charAt(
                    0
                  )}${selectedRmBuddy.name.charAt(1)}`.toUpperCase()}
                </h5>
              </Grid.Column>
              <Grid.Column width={4}>
                <div className="form-normal">
                  <label>Name</label>
                  <input type="text" value={name} onChange={setName} />
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <div className="form-normal">
                  <label>Phone Number</label>
                  <input
                    disabled
                    readonly
                    type="text"
                    value={phone_num}
                    onChange={setPhone_num}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <div className="form-normal">
                  <label>E-mail ID</label>
                  <input type="text" value={email} onChange={setEmail} />
                </div>
              </Grid.Column>
              <Grid.Column width={2}>
                <button onClick={saveHandler}>Done</button>
              </Grid.Column>
            </Grid>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
}

export default RMBuddyProfileEdit;
